import { Component, Input } from '@angular/core';
import { Variable } from '../../model/variable/variable';
import { VariableValue } from '../../model/variable/variable-value';
import { ComponentVariable } from '../component-variable';
import { VariableTypeComponent } from '../../model/variable/variable-type-component';
import { FormulaRunner } from '../../util/formula/formula-runner';


const HTML_TEMPLATE = `
<div>
    <ion-list>
        <div *ngFor="let variable of variables">
            <variable-input class="var-container" *ngIf="variable.typeComponent == variableInput && variable.typeVisibility != 'REPORT'"
                [variable]="variable" [callbackOnChange]="callbackChangeVariable.bind(this)"></variable-input>
            <variable-spinner class="var-container" *ngIf="variable.typeComponent == variableSpinner && variable.typeVisibility != 'REPORT'"
                [variable]="variable" [callbackOnChange]="callbackChangeVariable.bind(this)"></variable-spinner>
            <variable-formula class="var-container" *ngIf="variable.typeComponent == variableFormula && variable.typeVisibility != 'REPORT'"
                [variable]="variable" [callbackOnChange]="callbackChangeVariable.bind(this)"></variable-formula>
            <variable-checkbox class="var-container-one-line" *ngIf="variable.typeComponent == variableCheckbox && variable.typeVisibility != 'REPORT'"
                [variable]="variable" [callbackOnChange]="callbackChangeVariable.bind(this)"></variable-checkbox>
            <variable-toggle class="var-container-one-line" *ngIf="variable.typeComponent == variableToggle && variable.typeVisibility != 'REPORT'"
                [variable]="variable" [callbackOnChange]="callbackChangeVariable.bind(this)"></variable-toggle>
            <variable-radio class="var-container var-container-radio" *ngIf="variable.typeComponent == variableRadio && variable.typeVisibility != 'REPORT'"
                [variable]="variable" [callbackOnChange]="callbackChangeVariable.bind(this)"></variable-radio>
            <variable-select class="var-container" *ngIf="variable.typeComponent == variableSelect && variable.typeVisibility != 'REPORT'"
                [variable]="variable" [callbackOnChange]="callbackChangeVariable.bind(this)"></variable-select>
            <hr class="var-divider" />
        </div>
    </ion-list>
</div>
`;

const CSS_STYLE = `
.var-container {
    display: block;
    padding: 20px;
    padding-bottom: 0px;
    width: 100%;
}

.var-container-one-line {
    display: block;
    width: 100%;
    padding: 0px;
    padding-top: 10px !important;
}

.var-container-radio {
    padding-bottom: 12px !important;
}

.var-label-one-line {
    font-size: 14px;
    font-weight: bold !important;
    color: #4a5c60; 
}

.var-title {
    padding-top: 10px !important;
    font-size: 14px;
    font-weight: bold !important;
    color: #4a5c60;   
}

.var-optional {
    padding-top: 10px !important;
    font-size: 12px;
    color: #aaa;
    margin-left: 4px;
    font-style: italic;
    text-transform: lowercase;
}

.var-divider {
    margin-top: 8px;
}

.var-value-label {
    font-size: 32px;
    text-align: center;
}

.var-suffix {
    font-size: 24px;
    margin-left: -6px;
}

.var-edit-icon {
    font-size: 14px;
    color: #ccc;
}

.var-legend-noaction {
    color: #1485c7;
}

.var-legend-alert {
    color: #00b28e;
}

.var-legend-control {
    color: #ea9b3e;
}

.var-legend-damage {
    color: #c64840;
}
`;

@Component({
    selector: 'variable-list',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})
export class VariableListComponent {

    @Input('variables') variables: Variable[];
    public variableComponents: ComponentVariable[] = [];

    private variableCheckbox = VariableTypeComponent.CHECKBOX;
    private variableInput = VariableTypeComponent.INPUT;
    private variableRadio = VariableTypeComponent.RADIO;
    private variableSelect = VariableTypeComponent.SELECT;
    private variableSpinner = VariableTypeComponent.SPINNER;
    private variableToggle = VariableTypeComponent.TOGGLE;
    private variableFormula = VariableTypeComponent.FORMULA;

    constructor() {
        this.variableComponents = [];
    }

    callbackChangeVariable(component: ComponentVariable) {
        var index = this.variableComponents.indexOf(component);
        if (index !== -1) {
            this.variableComponents[index] = component;
        } else {
            this.variableComponents.push(component);
        }
        this.executeFormula();
    }

    private async executeFormula() {
        const variableValues = this.variableComponents.reduce((obj1, obj2) => {
            obj1[obj2.getVariable().code] = obj2.getValue().value;
            return obj1;
        }, {});

        const variablesFromComponents = this.variables
            .map(variable => {
                return {
                    identifier: variable.code,
                    value: variableValues[variable.code],
                    formula: variable.inspectionFormula
                };
            });

        const formulaComponents = this.variableComponents
            .filter(comp => comp.getVariable().typeComponent == 'FORMULA');

        for (const comp of formulaComponents) {
            const variable = comp.getVariable();
            const runner = new FormulaRunner(variable.inspectionFormula);
            variablesFromComponents.forEach(v => runner.addVariable(v));
            const response = await runner.run();

            let variableValue = variable.defaultValue;

            if (response.result) {
                variableValue = {
                    asBoolean: (response.result ? true : false),
                    asString:  response.result.toString(),
                    value:  response.result
                }
            }

            variablesFromComponents
                .filter(v => v.identifier == variable.code)
                .map(v => v.value = variableValue);

            comp.setValue(variableValue);
        }
    }

}
